export const BELL_RULE_LABELS = {
  // Dialog
  dialogTitle: 'Period Rules',

  // Section headers
  sectionAttendanceCodes: 'Attendance Codes',
  sectionTimingThresholds: 'Attendance Timing Thresholds',
  sectionAttendanceLogic: 'Attendance Logic',

  // Positive Attendance toggle
  positiveAttendance: 'Positive Attendance',

  // Attendance code field labels
  atReasonDefaultId: 'Kiosk Reason',
  atTypePresentId: 'Present',

  // Timing threshold field labels
  bellPeriodPreStartPresentSeconds: 'Minutes before bell - Present',
  bellPeriodPostStartTardySeconds: 'Minutes after bell - Tardy',
  bellPeriodPostStartAbsentSeconds: 'Minutes after bell - Absent',

  // Attendance Logic labels
  overridableAtTypesButton: 'Select types the kiosk entry can override',
  kioskOverwritePermission: 'Kiosk overwrite permission',
  isOutOfBuildingPropagationEnabled: 'Assign Out of Building code for each period after checkout',
  isNonAttendancePeriodsEnabled: 'Track attendance at open periods',
  isCreateInOutsEnabled: 'Create In/Out times on check-ins',
  isAttendanceApproveRequired: 'Push only approved attendance to Skyward',

  // PA Monitor field label
  paMode: 'Attendance Monitor',
  paModeExplanation: 'Automatically create absent records for class periods when no attendance is recorded.',
}

export const BELL_RULE_TOOLTIPS = {
  atTypePresentId:
    'The attendance code assigned when a student arrives early or on time.',
  bellPeriodPreStartPresentSeconds:
    'Number of minutes before the period starts a student can check in and be marked as early or on time.',
  bellPeriodPostStartTardySeconds:
    'Number of minutes after the period starts before a student is marked tardy.',
  bellPeriodPostStartAbsentSeconds:
    'Number of minutes after the period starts before a student is marked absent.',
  isPaEnabled:
    'Enables Positive Attendance tracking, which records when students arrive early or on time.',
  isOutOfBuildingPropagationEnabled:
    'When enabled, students who check out will automatically receive an Out of Building code for all subsequent periods.',
  isNonAttendancePeriodsEnabled:
    'When enabled, attendance is also tracked during open periods, such as lunch.',
  isCreateInOutsEnabled:
    'When enabled, In/Out time records are automatically created when students check in. Requires an Out of Building type to be selected.',
  isAttendanceApproveRequired:
    'When enabled, attendance records must be approved by a teacher before being pushed to Skyward.',
  paMode:
    'Determines how positive attendance is monitored and recorded.',
  overridableAtTypes:
    'Select which attendance types a kiosk entry can override when recording student attendance.',
}
